var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 512 512",
      transform: "scale(0.9)"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M75.067 39.366v-11.8C75.067 13.75 63.834 2.5 50 2.5c-13.816 0-25.066 11.25-25.066 25.067v11.8C19.15 39.85 14.6 44.732 14.6 50.632V64.7c0 18.083 14.7 32.8 32.783 32.8h5.234C70.7 97.5 85.4 82.783 85.4 64.7V50.633c0-5.9-4.55-10.783-10.334-11.267zm-39.283-11.8c.779-18.837 27.654-18.832 28.433 0v11.751H35.784zm10.25 42.151c-5.85-3.816-2.996-13.145 3.967-13.083 6.962-.059 9.82 9.262 3.966 13.083-.45.3-.733.834-.733 1.384v5.85c-.108 4.258-6.354 4.267-6.467 0V71.1c0-.55-.283-1.084-.733-1.384z",
    fill: "green",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b5a29233ec8a6af1e3bdc9508d32f69c.svg";
export { ForwardRef as ReactComponent };